import { z } from 'zod';
import { PROJECT_STATUSES } from '../../types/project.js';
import { visibilitySchema } from './common.js';

export const projectInputSchema = z.object({
  name: z.string().trim().min(1, 'トピック名を入力してください').max(100),
  description: z.string().trim().max(500),
  color: z
    .string()
    .trim()
    .regex(/^#[0-9a-fA-F]{6}$/, 'カラーは #RRGGBB 形式で'),
  status: z.enum(PROJECT_STATUSES as readonly [string, ...string[]]),
  visibility: visibilitySchema,
});

export type ProjectInputSchema = z.infer<typeof projectInputSchema>;
